export enum CostType {
  VirtualMachine = 1,
  PhysicalServer = 2,
  OtherSoftwareLicense = 5,
  AutomationSoftware = 6,
}
